export default {
  title: 'Do you have SOSAFE?',
  subtitle: "If yes, try SOSAFE's private messages",
  action: 'YES',
};
